import React, { PropTypes } from 'react';
import classnames from 'classnames';
import EmailSubscriptionForm from 'landing_pages/components/email_subscription_form';
import EmailSubscriptionForm2 from 'landing_pages/components/email_subscription_form_2';
import { trackGoogle } from 'common/tracking';

const trackSubscription = (action, label) => {
  trackGoogle("subscribed_email", action, label);
}

const SubscriptionHero2 = ({
  image, title, subtitle, security_code, submit_label, promo, className, formTitle,
  formClassName, background="#000630", showSingleNameField, hideNameFields, notice,
  pageUrlStem, successTitle, blockType, action_url, imageSide="left", titleCentered,
  redirectUrl, csTag, extraFields
}) => {

  const Form = csTag? EmailSubscriptionForm2 : EmailSubscriptionForm;

  return (
    <section className={classnames('block block-subs-hero-2', className)}
        style={{ background }} id="subs_hero">
      { titleCentered &&
      <div className="row columns">
        <div className="block-header">
          <h2 className="title">{ title }</h2>
        </div>
      </div> }
      <div className="row align-center align-middle">
        <div className={classnames("column small-16 large-7", { "large-order-2": imageSide === 'right' })}>
          <img src={image.url} alt={image.alt} />
        </div>
        <div className={classnames("column small-16 large-7", { "large-order-1": imageSide === 'right' })}>
          { !titleCentered && <h2 className="title">{ title }</h2> }
          <div className="subtitle" dangerouslySetInnerHTML={{ __html: subtitle }} />
          { redirectUrl?
          <a target="_blank" className="btn btn-tertiary" href={redirectUrl}>{ submit_label }</a>:
          <Form
            fullWidth={true}
            action_url={action_url}
            security_code={security_code}
            submit_label={submit_label}
            callback={trackSubscription.bind(null, blockType, (title || "").toLowerCase())}
            promo={promo}
            className={formClassName}
            background={background}
            showSingleNameField={showSingleNameField}
            hideNameFields={hideNameFields}
            notice={notice}
            pageUrlStem={pageUrlStem}
            formTitle={formTitle}
            successTitle={successTitle}
            csTag={csTag}
            extraFields={extraFields}
          /> }
        </div>
      </div>
    </section>
  );
}

SubscriptionHero2.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  image: PropTypes.object.isRequired,
  className: PropTypes.string,
  formClassName: PropTypes.string,
  formTitle: PropTypes.string,
  background: PropTypes.string,
  notice: PropTypes.string,
  security_code: PropTypes.string,
  submit_label: PropTypes.string,
  promo: PropTypes.string,
  showSingleNameField: PropTypes.bool,
  hideNameFields: PropTypes.bool,
  pageUrlStem: PropTypes.string.isRequired,
  successTitle: PropTypes.string,
  blockType: PropTypes.string.isRequired,
  action_url: PropTypes.string,
  imageSide: PropTypes.string,
  titleCentered: PropTypes.bool,
  redirectUrl: PropTypes.string,
  csTag: PropTypes.string,
  extraFields: PropTypes.array,
};

export default SubscriptionHero2;
